import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import UserCell from './view.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Props } from './view';
export default withFireUiAnalytics({
	onClick: 'userProfile',
})(UserCell);
